/* SEBBI — lightweight localStorage wishlist (no account needed, per device).
   - [data-sebbi-wishlist]  : cart "Move to Wishlist" (save + remove line)
   - [data-sebbi-wish]       : heart toggle (PDP / product cards / wishlist page)
   - [data-sebbi-wishlist-count] : live saved-count badge
   - [data-sebbi-wishlist-grid]  : wishlist page, rendered from storage
   Items are keyed by product handle (product-level wishlist). */
(function () {
  var KEY = 'sebbi:wishlist';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('sebbi:wishlist:change', { detail: { count: list.length } }));
  }
  function keyOf(it) { return String(it.handle || it.variant || it.url); }
  function itemFrom(el) {
    return {
      handle: el.getAttribute('data-handle') || '',
      variant: el.getAttribute('data-variant') || '',
      title: el.getAttribute('data-title') || '',
      url: el.getAttribute('data-url') || '',
      image: el.getAttribute('data-image') || '',
      price: el.getAttribute('data-price') || ''
    };
  }
  function has(it) { return read().some(function (x) { return keyOf(x) === keyOf(it); }); }
  function add(it) {
    var l = read();
    if (!l.some(function (x) { return keyOf(x) === keyOf(it); })) { it.ts = Date.now(); l.push(it); write(l); }
  }
  function removeItem(it) { write(read().filter(function (x) { return keyOf(x) !== keyOf(it); })); }
  function toggle(it) { if (has(it)) { removeItem(it); return false; } add(it); return true; }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function syncToggles() {
    var saved = read();
    document.querySelectorAll('[data-sebbi-wish]').forEach(function (b) {
      var it = itemFrom(b);
      var on = saved.some(function (x) { return keyOf(x) === keyOf(it); });
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function updateCounts() {
    var n = read().length;
    document.querySelectorAll('[data-sebbi-wishlist-count]').forEach(function (el) {
      if (el.textContent !== String(n)) el.textContent = n;   /* guard: avoid mutation loop */
      el.classList.toggle('is-empty', n === 0);
    });
  }

  function renderGrid() {
    var grid = document.querySelector('[data-sebbi-wishlist-grid]');
    if (!grid) return;
    var list = read().slice().reverse();
    var empty = document.querySelector('[data-sebbi-wishlist-empty]');
    if (!list.length) { grid.innerHTML = ''; if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;
    grid.innerHTML = list.map(function (it) {
      var media = it.image
        ? '<a class="sebbi-wl__media" href="' + esc(it.url) + '"><img src="' + esc(it.image) + '" alt="" loading="lazy"></a>'
        : '<a class="sebbi-wl__media sebbi-wl__media--empty" href="' + esc(it.url) + '"></a>';
      return '<article class="sebbi-wl__card">'
        + media
        + '<button type="button" class="sebbi-wl__remove" data-sebbi-wish data-handle="' + esc(it.handle) + '" aria-label="Remove from wishlist">&#10005;</button>'
        + '<a class="sebbi-wl__name" href="' + esc(it.url) + '">' + esc(it.title) + '</a>'
        + (it.price ? '<p class="sebbi-wl__price">' + esc(it.price) + '</p>' : '')
        + '</article>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    /* cart: move to wishlist = save + remove the line (reuse Horizon's remove) */
    var mv = e.target.closest('[data-sebbi-wishlist]');
    if (mv) {
      e.preventDefault();
      add(itemFrom(mv));
      var removeBtn = mv.parentElement && mv.parentElement.querySelector('.cart-items__remove');
      if (removeBtn) removeBtn.click();
      return;
    }
    /* heart toggle */
    var t = e.target.closest('[data-sebbi-wish]');
    if (t) {
      e.preventDefault();
      var on = toggle(itemFrom(t));
      t.classList.toggle('is-saved', on);
      t.setAttribute('aria-pressed', on ? 'true' : 'false');
      syncToggles();
      if (t.closest('[data-sebbi-wishlist-grid]')) renderGrid();
    }
  });

  document.addEventListener('sebbi:wishlist:change', updateCounts);
  document.addEventListener('DOMContentLoaded', function () { syncToggles(); updateCounts(); renderGrid(); });
  /* header is re-rendered on cart updates — re-sync the badge/hearts afterwards */
  document.addEventListener('cart:update', function () { setTimeout(function () { syncToggles(); updateCounts(); }, 50); });
  window.addEventListener('pageshow', function () { syncToggles(); updateCounts(); });
  document.addEventListener('shopify:section:load', function () { syncToggles(); updateCounts(); });

  /* the transparent header re-renders itself (scroll stages / morph), which replaces the
     badge with a fresh server copy (count 0). Re-sync whenever nodes are (re)injected. */
  var moTimer;
  var mo = new MutationObserver(function () {
    clearTimeout(moTimer);
    moTimer = setTimeout(function () { syncToggles(); updateCounts(); }, 80);
  });
  try { mo.observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}

  syncToggles(); updateCounts(); renderGrid();

  window.SebbiWishlist = { read: read, has: has, toggle: toggle, count: function () { return read().length; } };
})();
